<div class="reviews-outer">
  <h2 class="trinidad-bold" *ngIf="!(boondock$ | async)">Review this location.</h2>
  <h2 class="trinidad-bold" *ngIf="boondock$ | async">Review {{ (boondock$ | async)?.name }}.</h2>
  <p class="wizard-paragraph _12px">
    Let CurbNTurfers know what is available this boondocking locations. Complete the short rating process to help the
    community.
  </p>
  <div class="details-image" *ngIf="isOnline">
    <img
      [src]="getLargePhotoUrl((boondock$ | async)?.photos?.[0])"
      sizes="(max-width: 479px) 100vw, (max-width: 767px) 80vw, 466px"
      alt="Site Large Image"
    />
  </div>
  <div class="details-image" *ngIf="!isOnline">
    <img
      src="/img/wf/Computer_TruckCamper_CNT.svg"
      sizes="(max-width: 479px) 100vw, (max-width: 767px) 80vw, 466px"
      alt="Site Large Image"
    />
  </div>
  <div class="button-wrapper">
    <a class="button trinidad center w-button" (click)="onContinue()">Continue</a>
  </div>
</div>
